export function getAuditLabel(action, t) {
  if (!action) return '—';
  const raw = String(action).trim().toLowerCase();
  if (!raw) return '—';
  const key = raw.replace(/\s+/g, '_');
  const i18nKey = `audit.events.${key}`;
  const translated = typeof t === 'function' ? t(i18nKey) : i18nKey;
  if (translated === i18nKey) {
    const pretty = key.replace(/_/g, ' ');
    return pretty.charAt(0).toUpperCase() + pretty.slice(1);
  }
  return translated;
}
